import { UPDATE_START_OF_LAST_ITINERARY_SEARCH } from "./startOfLastItinerarySearchReducer"

export const updateStartOfLastItinerarySearch = (value) => ({
    type: UPDATE_START_OF_LAST_ITINERARY_SEARCH,
    payload: value
})